import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Settings = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg viewBox="0 0 25.753 26.644" width={size} height={size}>
      <title>{iconTitle}</title>
      <g data-name="Layer 2">
        <g data-name="Layer 7" fill="none" stroke={iconColor} strokeMiterlimit={10}>
          <path d="M17.091 10.434a8.382 8.382 0 0 0 .158-1.56 8.383 8.383 0 0 0-.158-1.559h-1.72a6.635 6.635 0 0 0-.804-1.928l1.226-1.226a8.418 8.418 0 0 0-2.206-2.205l-1.225 1.226a6.636 6.636 0 0 0-1.928-.804V.658A8.382 8.382 0 0 0 8.874.5a8.383 8.383 0 0 0-1.56.157v1.721a6.634 6.634 0 0 0-1.927.804L4.16 1.956A8.418 8.418 0 0 0 1.956 4.16L3.18 5.387a6.636 6.636 0 0 0-.803 1.928H.658A8.383 8.383 0 0 0 .5 8.875a8.382 8.382 0 0 0 .157 1.559h1.721a6.637 6.637 0 0 0 .803 1.928l-1.225 1.226a8.416 8.416 0 0 0 2.205 2.205l1.226-1.226a6.633 6.633 0 0 0 1.928.803v1.722a8.384 8.384 0 0 0 1.56.157 8.383 8.383 0 0 0 1.559-.157V15.37a6.637 6.637 0 0 0 1.928-.803l1.225 1.226a8.42 8.42 0 0 0 2.206-2.205l-1.226-1.226a6.636 6.636 0 0 0 .803-1.928zM8.874 11.58a2.706 2.706 0 1 1 2.706-2.706 2.706 2.706 0 0 1-2.706 2.706z" />
          <path
            d="M24.468 24.066a5.32 5.32 0 0 0 .898-1.925l-1.062-.496a4.519 4.519 0 0 0 .06-1.421l1.109-.403a5.734 5.734 0 0 0-.726-1.997l-1.11.404a4.52 4.52 0 0 0-.958-1.052l.496-1.062a5.322 5.322 0 0 0-1.925-.898l-.496 1.062a4.518 4.518 0 0 0-1.421-.06l-.403-1.11a5.733 5.733 0 0 0-1.997.727l.404 1.109a4.52 4.52 0 0 0-1.052.959l-1.062-.496a5.321 5.321 0 0 0-.898 1.925l1.062.495a4.52 4.52 0 0 0-.06 1.422l-1.11.403a5.732 5.732 0 0 0 .727 1.997l1.11-.404a4.517 4.517 0 0 0 .958 1.051l-.496 1.063a5.321 5.321 0 0 0 1.925.898l.496-1.062a4.52 4.52 0 0 0 1.42.06l.404 1.109a5.735 5.735 0 0 0 1.997-.726l-.404-1.11a4.52 4.52 0 0 0 1.051-.958zm-5.402-1.66a1.843 1.843 0 1 1 2.45-.89 1.843 1.843 0 0 1-2.45.89z"
            strokeWidth={0.5}
          />
        </g>
      </g>
    </svg>
  );
};

Settings.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Settings.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Settings);
